import React, {useState} from 'react';
import moment from 'moment/moment';
import {useNavigate} from 'react-router-dom';
import Trash from '../../SVG/Trash';
import {useSelector} from 'react-redux';
import {useRemoveFuelInspectionMutation} from '../../store/builder/inspections.api';
import useLoader from '../../global/UseLoadingHandler';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {toast} from 'react-toastify';
import {useTranslation} from '../../hooks/useTranslation';

const FuelReceiptRow = ({receipt, getFuelReceiptData, currentTab}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);

  const [showAction, setShowAction] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDeleteClicked, setIsDeleteClicked] = useState(false);

  const [removeFuel, {isLoading: fuelIsFetching, error, isSuccess, data}] =
    useRemoveFuelInspectionMutation();

  useLoader([fuelIsFetching]);

  const [] = useErrorHandler([error]);

  const renderDeleteModal = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p></p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setDeleteModal(false)}
            />
          </div>
          <div
            className='modal__content-body'
            style={{display: 'flex', justifyContent: 'center'}}
          >
            {t('fuelReceiptRow.modals.deleteMessage')}
          </div>
          <div className='modal__content-bottom'>
            <button className='close' onClick={() => setDeleteModal(false)}>
              {t('fuelReceiptRow.buttons.close')}
            </button>
            <button className='save danger' onClick={deleteFuel}>
              {t('fuelReceiptRow.buttons.yes')}
            </button>
          </div>
        </div>
        <div className='modal__bg' onClick={() => setDeleteModal(false)}></div>
      </div>
    );
  };

  const deleteFuel = () => {
    removeFuel(receipt?.id)
      .unwrap()
      .then(() => {
        toast.success('Successfully deleted fuel receipt');
        setDeleteModal(false);
        getFuelReceiptData();
      })
      .catch(() => {});
  };

  return (
    <div
      className='receipt__table-row seven-cols'
      key={receipt?.id}
      onMouseEnter={() => setShowAction(true)}
      onMouseLeave={() => setShowAction(false)}
      onClick={() => {
        if (!isDeleteClicked) {
          navigate(`/inspections/${receipt?.id}`, {
            // state: {readOnly: true},
          });
        }
        setIsDeleteClicked(false);
      }}
    >
      {deleteModal && renderDeleteModal()}
      <div className='receipt__table-bodyTh'>
        {receipt?.facility?.name ? receipt?.facility?.name : '---'}
      </div>
      <div className='receipt__table-bodyTh'>
        {receipt?.equipment?.title ? receipt?.equipment?.title : '---'}
      </div>
      <div className='receipt__table-bodyTh'>
        {receipt?.inspection_form?.name
          ? receipt?.inspection_form?.name
          : '---'}
      </div>
      <div className='receipt__table-bodyTh'>
        {receipt?.period ? receipt?.period : '---'}
      </div>
      <div className='receipt__table-bodyTh'>
        {receipt?.status ? receipt?.status : '---'}
      </div>
      {currentTab === 0 ? (
        <div className='receipt__table-bodyTh'>
          {receipt?.date ? moment(receipt?.submission_date).format('MM/DD/YY HH:mm:ss') : '---'}
        </div>
      ) : (
        <div className='receipt__table-bodyTh'>
          {receipt?.submission_date
            ? moment(receipt?.submission_date).format('MM/DD/YY HH:mm:ss')
            : '---'}
        </div>
      )}
      <div className='receipt__table-bodyTh'>
        {receipt?.submitted_user?.name ? receipt?.submitted_user?.name : '---'}
      </div>
      {(userInfo?.is_global || userInfo?.is_corporate || userInfo?.is_admin) &&
        receipt.can_be_deleted && (
          <div
            className={`receipt__table-delete ${showAction ? 'active' : ''}`}
            id={'receipt-delete'}
          >
            <div
              className='receipt__table-deleteBtn'
              onClick={e => {
                e.stopPropagation();
                setIsDeleteClicked(true);
                setDeleteModal(true);
              }}
            >
              <Trash color={'#DA6767'} />
            </div>
          </div>
        )}
    </div>
  );
};

export default FuelReceiptRow;
